module.exports = __webpack_public_path__ + "img/mc_square.0645de24.jpg";